
import request from '@/utils/request'
import { wisdomsitePrefix } from './config'
import Axios from 'axios'

export function personCount(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectScreen/personCount',
    method: 'post',
    data
  })
}
export function companyData(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectScreen/companyData',
    method: 'post',
    data
  })
}
export function querySiteProjectScreenConfig(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectScreenConfig/query',
    method: 'post',
    data
  })
}
export function updateSiteProjectScreenConfig(data) {
  return request({
    url: wisdomsitePrefix + '/front/siteProjectScreenConfig/addAndUpdate',
    method: 'post',
    data
  })
}
export const getWeatherOrigin = () => {
  return Axios.get('//v1.yiketianqi.com/api?unescape=1&version=v61&appid=14752271&appsecret=HdF65JQK')
}
